
import { Component, Vue } from "vue-property-decorator";
import Loading from "../../components/loading.vue";
import ResultTs from "./ts/result-ai";
import html2Pdf from "../../lib/html2pdf";
import CandidateAnswerSection from "@/views/paper/components/candidate-answer-section.vue";
import SvgImg from "@/components/videoPaly/index.vue";
import AudioStyle from "@/components/videoPaly/audioStyle.vue";
import AiGuide from "./guide.vue";
import EnglishProficiency from "./components/english/index.vue";
import Mandarin from "@/views/paper/components/mandarin/mandarin.vue";
import TooltipMaterials from "@/components/tooltip/index.vue";
import SingleDimensionMindRes from "@/components/single-dimension-mind-res.vue";
import DvfResV2 from "@/views/paper/components/dvf-res-v2.vue";
import Login from "@/views/paper/paper-result-report/login.vue"; //提取码登录
import { Report } from "@/lib/model/exam/candidate";
import { replaceBgCheckString } from "@/utils/common";

type LinkConfig = {
  link: string;
  x: number;
  y: number;
  width: number;
  height: number;
};
@Component({
  components: {
    DvfResV2,
    Loading,
    SvgImg,
    AudioStyle,
    CandidateAnswerSection,
    AiGuide,
    EnglishProficiency,
    Mandarin,
    TooltipMaterials,
    SingleDimensionMindRes,
    Login
  }
})
export default class PaperResultNew extends ResultTs {
  playTime = 0; // 记录答案播放进度
  lastPlayVideoIndex = -1; // 最后播放的视频序号
  navSerial = 1;
  showMoreImg = false;

  // 水印开关，默认启用
  watermarkEnabled = true;

  replaceBgCheckString = replaceBgCheckString;

  //获取结果图标
  get getResIcon() {
    if (this.candidate.aiRecommendStatus === 0) {
      return "";
    }

    return require(`@/views/paper/paper-result-report/assets/res-icon-${this.candidate.aiRecommendStatus}.png`);
  }

  get showGroupStar() {
    return this.all.reportShowConfig.hiddenDimensionGroupStar !== 1;
  }

  //是否折叠图片 换人检测
  get showMoreBtn() {
    return (
      this.candidate.replaceCheckResult.imgList.length > 6 && !this.showMoreImg
    );
  }

  // 展示填空题的参考答案
  get showReferenceAnswer() {
    return this.all.configGroup.showReferenceAnswer === 1;
  }

  //展示出的图片 换人检测
  get getImgList() {
    if (this.showMoreBtn) {
      return this.candidate.replaceCheckResult.imgList.slice(0, 5);
    } else {
      return this.candidate.replaceCheckResult.imgList;
    }
  }
  async wait(secends: number) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true);
      }, secends);
    });
  }

  created() {
    // this.start();
    //
  }
  // 缓存提取码对应的面试id
  reportCertiCodeCacheExamId = 0;
  // 是否需要提取码
  async needPassword(retryCount = 0): Promise<boolean | undefined> {
    try {
      const res = await Report.getInfo({
        connectCode: this.connectCode,
        tid: this.$route.query.tid as string
      });
      this.reportCertiCodeCacheExamId = res.reportCertiCodeCacheExamId;
      return res.needReportCertiCode;
    } catch (e) {
      console.error(e);
      // 可以根据重试次数决定是否再次调用
      if (retryCount < 3) {
        // 假设最多重试3次
        return this.needPassword(retryCount + 1);
      } else {
        // 达到最大重试次数后
        this.$message.error("网络不佳，请稍后重试吧");
      }
    }
  }

  showLogin = false;
  login() {
    this.showLogin = false;
    this.loadPage();
  }

  async checkPwd() {
    const needPwd = await this.needPassword(); //此处不封try catch，网络不通就需要停在这里
    if (needPwd) {
      //先判缓存的提取码是否正确
      const pass = await (this.$refs as any).login.checkLocalstroage();
      //不正确则展示提取码页面
      if (!pass) {
        this.showLogin = true;
      }
      return pass;
    }
    return true; //不需要提取码
  }

  async mounted() {
    this.connectCode = this.$route.query.connectCode as string;
    //是否需要输入提取码
    const pass = await this.checkPwd();
    if (!pass) return;
    this.loadPage();
    // 创建水印
    this.createWatermark();
  }
  loadPage() {
    this.open().finally(() => {
      if (this.$route.query.autoDownload === "1") {
        setTimeout(() => {
          this.downPDF();
        }, 2000);
      }
    });
  }
  linkConfigList: LinkConfig[] = [];
  setPDFLink() {
    const anchorList = (document.querySelectorAll(
      ".pdf-video-anchor"
    ) as unknown) as HTMLElement[];
    if (!anchorList.length) return;
    this.linkConfigList = [];
    const headToDown = "oss.hina.com";
    const headToPreview = "oss.hina.com";
    anchorList.forEach(item => {
      let link = item.getAttribute("pdf-video-url");
      if (link) {
        if (link.includes(headToDown)) {
          link = link.replace(headToDown, headToPreview);
        }
        const rect = item.getBoundingClientRect();
        this.linkConfigList.push({
          link,
          x: rect.left,
          // y: rect.top ,
          y: item.offsetTop,
          width: rect.width,
          height: rect.height
        });
      }
    });
  }
  async downPDF() {
    if (this.pdfIng) return false;
    this.showAiQuestion = true;
    this.showExamQuestion = true;
    this.showMoreImg = true;
    this.showMoreImgFace = true;
    this.showMoreImgWeb = true;
    this.pdfIng = true;
    await this.wait(1000);
    this.$nextTick(() => {
      const resultBox: HTMLElement = document.getElementById(
        "full"
      ) as HTMLElement;
      this.setPDFLink();

      html2Pdf.downloadPDF(
        resultBox,
        "AI面试报告-" + this.candidate.showName,
        false,
        this.linkConfigList,
        this.$route.query.autoDownload === "1"
      );
      setTimeout(() => {
        this.pdfIng = false;
      }, 2000);
    });
  }

  timeupdate({ target }: Event, answerIndex: number) {
    this.playTime = (target as HTMLMediaElement).currentTime * 1000;
    this.lastPlayVideoIndex = answerIndex;
  }

  questionIndexAppendIndex = {}; //正在播放的回答视频 { 题号: 追问index }

  onClickAsrItem(data: {
    answerIndex: number;
    appendIndex: number;
    time: number;
  }) {
    const refName = "PCvideo-" + data.answerIndex;
    this.questionIndexAppendIndex[data.answerIndex] = data.appendIndex;

    try {
      // 找到this.$refs中所有PCvideo-开头的元素，除要播放的以外的全部停止
      for (const key in this.$refs) {
        const element = this.$refs[key];
        if (key.indexOf("PCvideo-") === 0 && key !== refName) {
          element[0].pause();
        }
      }
      //当前题目播放器
      const videoPalyer = this.$refs[refName][0];

      if (!videoPalyer) return;
      //播放地址 默认主回答
      let videoUrl = this.answerList[data.answerIndex].aliyunVideoUrl;
      if (data.appendIndex > -1) {
        //播放地址 切换追问
        videoUrl = this.answerList[data.answerIndex].videoAppendAnswerList[
          data.appendIndex
        ].videoUrl;
      }
      videoPalyer.src = videoUrl;
      videoPalyer.poster = [
        "vod2.hina.com",
        "oss.hina.com",
        "vod.hina.com"
      ].includes(videoUrl)
        ? videoUrl + "?x-oss-process=video/snapshot,t_2000,f_jpg,ar_auto"
        : "";
      videoPalyer.currentTime = data.time / 1000 + 0.01; // 这个地方+0.01防止上一句话闪一下
      videoPalyer.play();
    } catch (e) {
      console.log(e);
    }
  }

  // 自动播放下一个追问
  onEnded(questionIndex: number) {
    const questionLen = this.answerList[questionIndex].videoAppendAnswerList
      .length;

    if (!questionLen) return;

    const appendIndex = this.questionIndexAppendIndex?.[questionIndex] ?? -1;

    if (appendIndex < questionLen - 1) {
      this.onClickAsrItem({
        answerIndex: questionIndex,
        appendIndex: appendIndex + 1,
        time: 0
      });
    }
  }
  //前一个追问
  preAppend(questionIndex: number) {
    const appendIndex = this.questionIndexAppendIndex?.[questionIndex] ?? -1;

    if (appendIndex > -1) {
      this.onClickAsrItem({
        answerIndex: questionIndex,
        appendIndex: appendIndex - 1,
        time: 0
      });
    }
  }
  //下一个追问
  nextAppend(questionIndex: number) {
    const appendIndex = this.questionIndexAppendIndex?.[questionIndex] ?? -1;
    const questionLen = this.answerList[questionIndex].videoAppendAnswerList
      .length;

    if (appendIndex < questionLen - 1) {
      this.onClickAsrItem({
        answerIndex: questionIndex,
        appendIndex: appendIndex + 1,
        time: 0
      });
    }
  }
}
